import React from 'react';

function HelpPage() {
  return <div className='h-screen'></div>;
}

export default HelpPage;
